<div class="therapyContainer">
  <div class="title">
    <itl-detail-title-therapy-icon [therapyId]="medicalOrderData?.therapyId"></itl-detail-title-therapy-icon>
    <div class="therapy">
      <div class="name" [style.color]="medicalOrderData?.therapyId | therapyColor ">
        {{ medicalOrderData?.therapyId| therapy }}
      </div>
      <div class="therapyType">{{ medicalOrderData?.therapyTypeId | therapyType }}</div>
    </div>
  </div>
</div>

<itl-detail-item>
  <itl-detail-item-icon>
    <ion-icon name="alberta-activity-date"></ion-icon>
  </itl-detail-item-icon>
  <div class="scope">
    {{'medicalOrder.create.scope' | translate}}:
    <span class="bold"
      >{{medicalOrderData.startDate | date:'dd.MM.yyyy'}} - {{medicalOrderData.endDate | date:'dd.MM.yyyy'}}</span
    >
  </div>
</itl-detail-item>

<div class="articleLineContainer">
  <div class="articleHeader">{{'medicalOrder.create.listedServices' |translate}}</div>
  <itl-warning-item *ngIf="!medicalOrderData.serviceLines?.length">
    <div class="warningText">{{'medicalOrder.create.noServices_warning' |translate}}</div>
  </itl-warning-item>
  <itl-medical-order-service-data
    *ngFor="let orderedService of medicalOrderData.serviceLines"
    [serviceLine]="orderedService"
  >
  </itl-medical-order-service-data>
</div>

<div *ngIf="medicalOrderData?.notAvailableServiceLines.length" class="articleLineContainer">
  <div class="articleHeader">{{'medicalOrder.create.unlistedServices' |translate}}</div>
  <div class="unlistedArticleInfo">{{'medicalOrder.create.unlistedServices_info' |translate}}</div>
  <itl-medical-order-service-data
    *ngFor="let serviceLine of medicalOrderData.notAvailableServiceLines"
    [serviceLine]="serviceLine"
  >
  </itl-medical-order-service-data>
</div>

<itl-textarea
  [(ngModel)]="medicalOrderData.diagnose"
  [title]="'integratedCare.diagnose' | translate"
  [placeholder]="'integratedCare.diagnose_placeholder' | translate"
  icon="alberta-diagnosis"
></itl-textarea>

<itl-info-box *ngIf="correspondenceNotVerified" [type]="InfoBoxType.Information"
  >{{ 'medicalOrder.create.doctorNotVerified' | translate }}</itl-info-box
>

<itl-autocomplete
  [(selected)]="medicalOrderData.doctorId"
  [useLogicalAnd]="true"
  [placeholder]="'medicalOrder.create.doctor_placeholder' | translate"
  type="doctor"
  icon="alberta-doctor"
  [showDeleteButton]="false"
  [title]="'medicalOrder.create.doctor' | translate"
  [fullPageModal]="true"
  (selectedChange)="doctorChanged($event)"
  [fullPageModal]="true"
></itl-autocomplete>
<div class="recipientData">
  <itl-selection
    [title]="'medicalOrder.create.correspondenceType' | translate"
    [placeholder]="'medicalOrder.create.correspondenceType_placeholder' | translate"
    [(ngModel)]="medicalOrderData.correspondenceType"
    [values]="correspondenceTypes"
    icon="alberta-contact-data"
    [required]="true"
    (change)="correspondenceTypeChanged($event)"
  ></itl-selection>

  <ng-container [formGroup]="correspondenceAddressForm">
    <itl-text
      *ngIf="shouldShowCorrespondenceAddress"
      formControlName="to"
      [title]="'medicalOrder.create.to' | translate"
      icon="alberta-address-book"
      [placeholder]="'medicalOrder.create.to_placeholder' | translate"
      [required]="shouldShowCorrespondenceAddress"
      [(ngModel)]="medicalOrderData.to"
    >
    </itl-text>
  </ng-container>
</div>
